import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Form, Radio} from 'semantic-ui-react';
import withChangeHandler from './withChangeHandler';

const MANAGED_PROPS = [
  'id',
  'questionLabel',
  'questionText',
  'title',
  'modelKey',
  'value',
  'style',
];

const RadioWithChangeHandler = withChangeHandler(Form.Radio);

export default class extends React.Component {
  static propTypes = {
    /** A unique id */
    id: PropTypes.string,

    /** The label for the question */
    questionLabel: PropTypes.string,

    /** The text for the question */
    questionText: PropTypes.string.isRequired,

    /** The unique key of the property within the form backing model */
    modelKey: PropTypes.string.isRequired,

    /** The current value of the field */
    value: PropTypes.any,

    /** A collection of possible answers (radio options) */
    options: PropTypes.array,
  };

  constructor(props) {
    super(props);
    const defaultOptions = [
      {label: 'Yes', value: 'Y'},
      {label: 'No', value: 'N'},
      {label: 'Not applicable', value: 'N/A'},
    ];

    this.id = props.id;
    this.modelKey = props.modelKey;
    this.questionText = props.questionText;
    this.options = props.options || defaultOptions;
    this.state = {};
  }

  render = () => {
    const filteredProps = _.omit(this.props, MANAGED_PROPS);

    return (
      <div id={this.id} style={this.props.style}>
        <Form.Field className="questionText indent">{this.questionText}</Form.Field>
        {this.options.map((option) => {
          const {label} = option;
          let checked = this.props.value === option.value;

          if (checked === false && option.value === 'Y') {
            if (this.props.value === true) {
              checked = true;
            }
          } else if (checked === false && option.value === 'N') {
            if (this.props.value === false) {
              checked = true;
            }
          }
          return (
            <Form.Field key={option.value}>
              <RadioWithChangeHandler
                className="indent"
                name={this.id}
                {...option}
                title={label}
                modelKey={this.modelKey}
                updateModel={this.props.updateModel}
                checked={checked}
                {...filteredProps}
                disabled={option.disabled}
                saveReduxOnChange={true}
              />
            </Form.Field>
          );
        })}
      </div>
    );
  };
}
